import React, { useState, useEffect } from 'react';

// Static tips - defined outside component to avoid re-creating on every render
const tips = [
  'Split bills with friends effortlessly',
  'Track expenses in real-time',
  'Settle up with crypto or cash',
  'Support for 150+ currencies',
  'Lightning-fast settlements',
];

const LoadingScreen: React.FC = () => {
  const [progress, setProgress] = useState(0);
  const [tip, setTip] = useState('');

  useEffect(() => {
    // Show random tip
    setTip(tips[Math.floor(Math.random() * tips.length)]);

    // Simulate progress (psychological effect)
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) return prev; // Stop at 90%, complete on actual load
        return prev + Math.random() * 15;
      });
    }, 200);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-screen">
      <div className="loading-card">
        <img src="/logo.svg" alt="Settler logo" />
        <h2>Settler</h2>
        <p className="loading-tip">{tip}</p>
        
        {/* Progress bar */}
        <div className="progress-container">
          <div 
            className="progress-bar" 
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;

